import React, { useEffect, useState } from 'react';
import styles from './InventoryModal.module.css';

const InventoryModal = ({ data, onClose }) => {
  const [filter, setFilter] = useState('all'); // 'all' | 'success' | 'failed'

  const isFailed = (item) => item.status === 'FAILED';
  // Treat anything not explicitly failed as success (handles 'SUCCESS'/'SUCEESS').
  const isSuccess = (item) => !isFailed(item);

  const successCount = data.filter(isSuccess).length;
  const failedCount = data.filter(isFailed).length;
  const total = data.length;

  // Failed items first, then filter by the active tab.
  const sortedData = [...data].sort((a, b) => {
    if (isFailed(a) && isSuccess(b)) return -1;
    if (isSuccess(a) && isFailed(b)) return 1;
    return 0;
  });

  const visibleData = sortedData.filter((item) => {
    if (filter === 'success') return isSuccess(item);
    if (filter === 'failed') return isFailed(item);
    return true;
  });

  // Close on Escape key.
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.content} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className={styles.header}>
          <div>
            <h2 className={styles.title}>Inventory Update Summary</h2>
            <p className={styles.subtitle}>
              {total} item{total !== 1 ? 's' : ''} processed
            </p>
          </div>
          <button className={styles.iconClose} onClick={onClose} aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>

        {/* Stat cards */}
        <div className={styles.stats}>
          <div className={`${styles.stat} ${styles.statSuccess}`}>
            <span className={styles.statValue}>{successCount}</span>
            <span className={styles.statLabel}>Updated</span>
          </div>
          <div className={`${styles.stat} ${styles.statFailed}`}>
            <span className={styles.statValue}>{failedCount}</span>
            <span className={styles.statLabel}>Failed</span>
          </div>
        </div>

        {/* Filter tabs */}
        <div className={styles.tabs}>
          <button
            className={`${styles.tab} ${filter === 'all' ? styles.tabActive : ''}`}
            onClick={() => setFilter('all')}
          >
            All <span className={styles.tabCount}>{total}</span>
          </button>
          <button
            className={`${styles.tab} ${filter === 'success' ? styles.tabActive : ''}`}
            onClick={() => setFilter('success')}
          >
            Updated <span className={styles.tabCount}>{successCount}</span>
          </button>
          <button
            className={`${styles.tab} ${filter === 'failed' ? styles.tabActive : ''}`}
            onClick={() => setFilter('failed')}
          >
            Failed <span className={styles.tabCount}>{failedCount}</span>
          </button>
        </div>

        {/* Results list */}
        <ul className={styles.statusList}>
          {visibleData.length === 0 ? (
            <li className={styles.empty}>No items in this category.</li>
          ) : (
            visibleData.map((item, index) => {
              const failed = isFailed(item);
              return (
                <li
                  key={index}
                  className={`${styles.statusItem} ${failed ? styles.failed : styles.success}`}
                >
                  <span className={styles.statusIcon} aria-hidden="true">
                    {failed ? (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2.6"
                        strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                      </svg>
                    ) : (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2.6"
                        strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 6 9 17l-5-5" />
                      </svg>
                    )}
                  </span>
                  <div className={styles.itemText}>
                    <span className={styles.itemCode}>{item.itemCode}</span>
                    <span className={styles.itemDesc}>{item.description}</span>
                  </div>
                </li>
              );
            })
          )}
        </ul>

        {/* Footer */}
        <div className={styles.footer}>
          <button onClick={onClose} className={styles.closeBtn}>Done</button>
        </div>
      </div>
    </div>
  );
};

export default InventoryModal;